module.exports = "<p>\n  russian works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/meme/src/app/russian/russian.component.html
// module id = ../../../../../src/app/russian/russian.component.html
// module chunks = main